'use client';

import { c as _c } from "react/compiler-runtime";
import SettingConfig from '@module/config/setting';
import useGradeTableViewModel from '@module/helpers/channel/grade/useGradeTableViewModel';
import formatNumberWithComma from '@module/utils/formatNumberWithComma';
import BaseButton from '@pc/components/atoms/button/BaseButton';
import NoticeCard, { type NoticeList } from '@pc/components/card/NoticeCard';
import { Input } from '@pc/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@pc/components/ui/select';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@pc/components/ui/table';
import { useParams } from 'next/navigation';
const notices: NoticeList = ['최대 설정가능한 하트 개수는 1,000,000개 입니다.', '방송 중 설정한 등급은 다음 방송 부터 정상 적용됩니다.', '등급은 선물한 날짜부터 유효기간까지 선물한 개수에 따라 지정됩니다.', '팬 등급 영구지정은 팬랭킹 페이지에서 개인별 지정이 가능합니다.', '영구 지정된 팬등급보다 높은 팬등급이 달성되면 높은 팬등급으로 표기됩니다.', '현재의 팬등급 보다 낮은 등급으로 영구팬 지정도 가능하나, 현재 팬등급 기간 종료 후 해당 영구 팬등급이 노출됩니다.'];
const HEART_LIMIT_COUNT = 1000000;
function GradeTableContainer() {
  const $ = _c(17);
  const params = useParams();
  const channelId = params?.id ? decodeURIComponent(params.id) : "";
  const {
    bjInfoData,
    isMyChannel,
    getStateByLevel,
    handleEditButtonClick
  } = useGradeTableViewModel(channelId);
  if (!bjInfoData?.fanGrade) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <colgroup><col width="43%" /><col width="26%" /><col width="31%" /></colgroup>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <TableHeader><TableRow className="h-[50px]"><TableHead className="text-center">{"\uB4F1\uAE09"}</TableHead><TableHead className="text-center">{"\uD558\uD2B8\uAC1C\uC218"}</TableHead><TableHead className="text-center">{"\uC720\uD6A8\uAE30\uAC04"}</TableHead></TableRow></TableHeader>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== bjInfoData.fanGrade || $[3] !== getStateByLevel || $[4] !== isMyChannel) {
    let t3;
    if ($[6] !== getStateByLevel || $[7] !== isMyChannel) {
      t3 = item => <TableRow key={item.level} className="text-lg"><TableCell className="px-[100px]"><div className="flex w-full items-center"><img alt="gd" src={`${SettingConfig.S3_BUCKET_URL}/img/grade/grade_${item.level}.svg`} width={24} height={24} className="mr-3" />{isMyChannel ? <Input containerClassName="h-[40px]" className="w-[290px]" value={getStateByLevel(item.level)?.name} onChange={e => getStateByLevel(item.level)?.setName(e.currentTarget.value)} /> : <span>{getStateByLevel(item.level)?.name}</span>}</div></TableCell><TableCell>{isMyChannel ? <div className="flex items-center justify-center"><Input containerClassName="h-[40px]" className="text-right" value={getStateByLevel(item.level)?.coin} onChange={e_0 => {
              const newValue = e_0.currentTarget.value;
              const coin = Number(newValue);
              if (typeof coin !== "number") {
                return;
              }
              if (Number.isNaN(coin)) {
                return;
              }
              if (coin > HEART_LIMIT_COUNT) {
                getStateByLevel(item.level)?.setCoin(String(HEART_LIMIT_COUNT));
                return;
              }
              getStateByLevel(item.level)?.setCoin(newValue);
            }} />  개</div> : <span>{`${formatNumberWithComma(getStateByLevel(item.level)?.coin)} 개`}</span>}</TableCell><TableCell className="text-center">{isMyChannel ? <div className="flex justify-center"><Select value={String(getStateByLevel(item.level)?.expDay)} onValueChange={value => getStateByLevel(item.level)?.setExpDay(Number(value))}><SelectTrigger className="w-[116px] bg-transparent"><SelectValue /></SelectTrigger><SelectContent className="w-[116px]"><SelectItem value="30">{"30\uC77C"}</SelectItem><SelectItem value="60">{"60\uC77C"}</SelectItem><SelectItem value="90">{"90\uC77C"}</SelectItem></SelectContent></Select></div> : <span>{`${getStateByLevel(item.level)?.expDay}일`}</span>}</TableCell></TableRow>;
      $[6] = getStateByLevel;
      $[7] = isMyChannel;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = bjInfoData.fanGrade.map(t3);
    $[2] = bjInfoData.fanGrade;
    $[3] = getStateByLevel;
    $[4] = isMyChannel;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[9] !== t2) {
    t3 = <Table>{t0}{t1}<TableBody>{t2}</TableBody></Table>;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== handleEditButtonClick || $[12] !== isMyChannel) {
    t4 = isMyChannel && <><BaseButton className="mt-10 mb-20 h-[48px] w-[120px]" variant="primary" size="md" onClick={handleEditButtonClick}>{"\uC801\uC6A9\uD558\uAE30"}</BaseButton><NoticeCard title={"\uD32C\uB4F1\uAE09 \uC801\uC6A9\uC548\uB0B4"} noticeList={notices} /></>;
    $[11] = handleEditButtonClick;
    $[12] = isMyChannel;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t3 || $[15] !== t4) {
    t5 = <div className="mb-20 flex w-full flex-col items-center text-colorFg18">{t3}{t4}</div>;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}
export default GradeTableContainer;